<template>
  <v-dialog
    v-model="isOpen"
    max-width="600"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        <div class="columns">
          <div class="column" v-if="isCreate">
            <h2 class="title is-3">Создать аккаунт Click2Money</h2>
          </div>
          <div class="column" v-else>
            <h2 class="title is-3">Изменить аккаунт Click2Money: {{ currentClick2moneyAccountName }}</h2>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout row>
          <v-layout column>
            <b-field label="Название">
              <b-input v-model="currentClick2moneyAccount.name"></b-input>
            </b-field>

            <b-field label="Click2Money ID">
              <b-input type="number" v-model="currentClick2moneyAccount.click2money_id"></b-input>
            </b-field>

            <b-field label="Токен">
              <b-input v-model="currentClick2moneyAccount.token"></b-input>
            </b-field>

            <b-field label="Избранный">
              <b-switch v-model="currentClick2moneyAccount.is_favorite">{{currentClick2moneyAccount.is_favorite ? 'Да' : 'Нет'}}</b-switch>
            </b-field>

          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" v-if="isCreate" @click="createClick2moneyAccount()">Добавить</v-btn>
        <v-btn text color="primary" v-else @click="updateClick2moneyAccount()">Обновить</v-btn>
      </v-card-actions>
      <overlay-loader :show="isLoading"></overlay-loader>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';
import { toFormData } from '@/app/shared/services/helpers';

export default {
  name: 'Click2moneyAccountDetailsModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
      currentClick2moneyAccountName: '',
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.currentClick2moneyAccountName = this.currentClick2moneyAccount.name;
      }
    },
  },
  computed: {
    isCreate() {
      return this.currentClick2moneyAccount.id == null;
    },
    isLoading: {
      get() {
        return this.$store.getters.GET_CLICK2MONEY_ACCOUNT_DETAILS_MODAL_LOADING;
      },
      set(value) {
        this.$store.commit('SET_CLICK2MONEY_ACCOUNT_DETAILS_MODAL_LOADING', value);
      }
    },
    isOpen: {
      get() {
        return this.$store.getters.GET_CLICK2MONEY_ACCOUNT_DETAILS_MODAL_OPENED;
      },
      set() {
        this.$store.commit('SET_CLICK2MONEY_ACCOUNT_DETAILS_MODAL_OPENED', false);
      },
    },
    currentClick2moneyAccount: {
      get() {
        return this.$store.getters.GET_CURRENT_CLICK2MONEY_ACCOUNT;
      },
      set(value) {
        this.$store.commit("SET_CURRENT_CLICK2MONEY_ACCOUNT", value);
      },
    },
  },
  methods: {
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    close() {
      this.currentClick2moneyAccount = {}; // Очистка текущего аккаунта
      this.isOpen = false;
    },
    createClick2moneyAccount() {
      this.$store.dispatch('CREATE_CLICK2MONEY_ACCOUNT', toFormData(this.currentClick2moneyAccount))
        .then(() => {
          this.$toast.success("Click2Money аккаунт создан!");
        })
        .catch((error) => {
          this.$toast.error(error);
        }).finally(() => {
        this.close();
      });
    },
    updateClick2moneyAccount() {
      let data = {
        id: this.currentClick2moneyAccount.id,
        form: toFormData(this.currentClick2moneyAccount)
      }
      this.$store.dispatch('UPDATE_CLICK2MONEY_ACCOUNT', data)
        .then(() => {
          this.$toast.success("Click2Money аккаунт успешно изменен");
          this.close();
        })
        .catch(() => {
          this.$toast.error("Ошибка при изменении аккаунта");
        });
    }
  },
};
</script>
